import React, { useState, useRef } from "react";
import FeaturedCard from "./FeaturedCard";
import ViewBusiness from "./ViewBusiness";
import "./FeaturedServices.css";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

const FeaturedServices = ({
  businessData = [],
  services = [],
  loading,
  setShowAllServices,
  searchResults
}) => {
  const [selectedBusiness, setSelectedBusiness] = useState(null);
  const scrollRef = useRef(null);

  // Combine both business and service data (fallback sample for testing)
  const combinedData =
    businessData.length || services.length
      ? [...businessData, ...services]
      : [
          {
            id: 1,
            serviceName: "HomeChef Priya",
            description: "Authentic home-style catering",
            location: "Chennai",
            serviceCategory: "Food & Catering",
            imageUrl: "https://images.unsplash.com/photo-1504754524776-8f4f37790ca0",
          },
          {
            id: 2,
            serviceName: "Anjali’s Boutique",
            description: "Custom tailoring & alterations",
            location: "Pune",
            serviceCategory: "Fashion & Tailoring",
            imageUrl: "https://images.unsplash.com/photo-1520975922131-205d3ca191d3",
          },
          {
            id: 3,
            serviceName: "Meera’s Tutoring Hub",
            description: "Expert tuitions for grades 1–12",
            location: "Bangalore",
            serviceCategory: "Education",
            imageUrl: "https://images.unsplash.com/photo-1584697964358-3b47f9f2be51",
          },
        ];

  const handleScroll = (direction) => {
    const container = scrollRef.current;
    if (!container) return;
    const scrollAmount = container.clientWidth * 0.8;
    container.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  const handleViewBusiness = (business) => setSelectedBusiness(business);

  if (selectedBusiness) {
    return (
      <ViewBusiness
        business={selectedBusiness}
        onBack={() => setSelectedBusiness(null)}
      />
    );
  }

  return (
    <section className="featured-section">
      <div className="featured-header">
        <div>
          <h2 className="featured-title">Featured Verified Sellers</h2>
          <p className="featured-subtitle">
            Top-rated women entrepreneurs trusted by thousands
          </p>
        </div>
        <button
          className="featured-view-all-btn"
          onClick={() => setShowAllServices && setShowAllServices(true)}
        >
          View All →
        </button>
      </div>

      <div className="featured-carousel-wrapper">
        <button
          className="scroll-btn left"
          onClick={() => handleScroll("left")}
        >
          <FaArrowLeft />
        </button>

        <div className="featured-carousel" ref={scrollRef}>
          {loading ? (
            <div className="featured-loading">Loading...</div>
          ) : (
            combinedData.map((item, index) => (
              <div key={index} className="featured-card-wrapper">
                <FeaturedCard
                  item={item}
                  type={item.directoryId ? "business" : "service"}
                  onViewBusiness={handleViewBusiness}
                />
              </div>
            ))
          )}
        </div>

        <button
          className="scroll-btn right"
          onClick={() => handleScroll("right")}
        >
          <FaArrowRight />
        </button>
      </div>
    </section>
  );
};

export default FeaturedServices;
